import type { PropType } from 'vue'
import { defineComponent } from 'vue'

import { colors } from '@/assets/scss/variables'

import { glyphs } from './glyphs'
import type { IconName } from './types'

export type Colors = keyof typeof colors

export type Props = {
  readonly color?: Colors
  readonly name: IconName
  readonly size?: IconSize | number
  readonly style?: HTMLSpanElement['style']
}

const emptyObject = {}

export const KcalmarIcon = defineComponent(
  (props: Props) => {
    const { name, size = 24, color: _color, style = emptyObject } = props

    const fontSize = `${size}px`
    const color = _color ? colors[_color] : undefined

    return () => (
      <span
        style={{
          color,
          fontFamily: 'Icon',
          fontSize,
          ...style,
          height: fontSize,
          lineHeight: fontSize,
          width: fontSize,
        }}
      >
        {glyphs[name]}
      </span>
    )
  },
  {
    props: {
      color: String as PropType<Colors>,
      name: String as PropType<IconName>,
      size: [String, Number] as PropType<IconSize>,
      style: Object as PropType<HTMLSpanElement['style']>,
    },
  },
)
